import React, { useEffect, useState } from 'react';
import classes from "./ConfirmationPage.module.css";
import Header from '../components/Header';
import { useLocation, useNavigate } from 'react-router-dom';
import { login,subscribeApi } from '../http/http';
import { useDispatch } from 'react-redux';
import { setUserToken } from '../store/slices/userTokenSlice';
import { toast } from 'react-toastify';
import SmallLoader from '../components/Loaders/SmallLoader';
import { useTranslation } from 'react-i18next';

const ConfirmationPage = () => {

    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [msisdn, setMsisdn] = useState(null);
    const [extRef, setExtRef] = useState(null);
    const [pack,setPack]=useState(null);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
        if (location?.state?.msisdn) {
            setMsisdn(location?.state?.msisdn);
            setExtRef(location?.state?.extRef);
            setPack(location?.state?.pack);
        }
        else {
            navigate("/");
        }
    }, [location]);
   const handleFormSubmission = async () => {
        try {
            setLoading(true);
            await subscribeApi(msisdn, pack, extRef)
                .then(async (res) => {
                    if (res?.data.status == 1) {
                        setLoading(false);
                        // dispatch(setUserToken(res?.data?.result?.token));
                        try {
                            await login({ msisdn: msisdn }).then((r) => {



                                dispatch(setUserToken(r?.data?.result?.token));

                                navigate("/home", { replace: true, state: null });
                            })
                        } catch (e) {
                            toast.error(t("136"));

                            setTimeout(() => {
                                navigate("/low-balance");
                            }, 3000)
                        }
                    } else {
                        if (res?.data.status == 2) {
                            toast.error(t("136"));

                            navigate("/home", { replace: true, state: null });
                            setTimeout(() => {
                                navigate("/low-balance");
                            }, 3000)
                        }
                    }
                })
                .catch((err) => {
                    setLoading(false);
                    console.log(err, 'err---');
                });
        } catch (error) {
            setLoading(false);
            console.log(error, 'error--');
        }
    }

    return (
        <>
            <Header />
            <div className={classes.container}>
                <div className={classes.description}>
                    <h2 className={classes.title}>{t("76")}</h2>
                    <p className={classes.text}>
                        {t("77")} <span className={classes.bold}>{pack==="Daily" ? t("106") : t("107")}</span>.{" "}
                        {t("79")}
                    </p>
                </div>

                <div className={classes.buttons_container}>
                    <button type='button' disabled={loading} className={classes.button} onClick={handleFormSubmission}>
                        {loading ? <SmallLoader /> : t("80")}
                    </button>
                    <button type='button' disabled={loading} className={classes.no_button} onClick={() => navigate("/")}>
                        {t("81")}
                    </button>
                </div>
            </div>
        </>

    )
}

export default ConfirmationPage